import spike from '../images/spike.png';
import mike from '../images/dynamike.png';
import { Button } from 'reactstrap';

const HowTo = ({ competitionEnded }) => (
  <section className="section-padding position-relative">
    <img
      src={mike}
      alt="Dynamike"
      className="position-absolute top-0 end-0 d-none d-md-block z-1"
    />
    <img src={spike} alt="Spike" className="position-absolute bottom-0 start-0 d-none d-md-block" />
    <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div className="card mb-5">
            <h2 className="card-header text-uppercase">How to Play</h2>
            <div className="card-body">
              <p className="card-text">
                Spin the challenge wheel to receive a randomized Brawl Stars challenge.
              </p>
              <p className="card-text">
                If you successfully complete a challenge, move up a level and spin again for the
                next challenge. If you fail, you can try again.
              </p>
              <p className="card-text">
                You must successfully complete 3 challenges to make it to the top.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className={`card ${competitionEnded ? 'card-download-ended' : 'card-download'}`}>
            <h2 className="card-header text-uppercase">How to enter</h2>
            <div className="card-body">
              {competitionEnded ? (
                <>The competition and giveaway are closed at this time.</>
              ) : (
                <>
                  <p className="card-text">Film yourself attempting the challenge.</p>
                  <p className="card-text">
                    Tweet your competition video and tag @BrawlStars using #RacetoGemMountain for a
                    chance to win a limited edition Spike Nendoroid figurine!
                  </p>
                  <Button
                    tag="a"
                    href="./Gem-Mountain-Assets.zip"
                    size="sm"
                    color="primary"
                    download
                    className="text-uppercase"
                  >
                    Download All Assets
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HowTo;
